import React, { useImperativeHandle, useRef, useState } from "react";
import { RCCRefModalProps } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import Modal from "../Modal";
import Iniciatives from "./Iniciatives";
import IModalIniciatives, { IRefIniciativeModals, TypeIniciative } from "./interface";

const ModalIniciatives: React.ForwardRefRenderFunction<IRefIniciativeModals, IModalIniciatives> = ({ 
	onCallbackIniciatives,
	disabled
}, ref) => {
	const { translate } = useTranslation(); 

	const [idKr, setIdKr] = useState<number>();
	const [idObjective, setIdObjective] = useState<number>();
	const [subtitle, setSubtitle] = useState<string>("");
	const [permissions, setPermissions] = useState(2);
	const onCallbackIniciativesFunction = useRef<Function | undefined>();

	const modalAddOrChangeObjectives = useRef<RCCRefModalProps>(null);

	const openModalIniciative = async (typeIniciative: TypeIniciative, newSubTitle: string, onCallback?: () => void, permissionsX?: number) => {
		setIdKr(typeIniciative.idKr);
		setPermissions(permissionsX ?? 2);
		setIdObjective(typeIniciative.idObjective);
		createSubtitle(typeIniciative, newSubTitle);
		onCallbackIniciativesFunction.current = onCallback;
		modalAddOrChangeObjectives.current?.openModal();
	};

	const createSubtitle = (typeIniciative: TypeIniciative, newSubTitle: string) => {
		if(typeIniciative.idObjective){
			setSubtitle(`${translate("Objetivo")}: ${newSubTitle}`);
			return;
		}

		if(typeIniciative.idKr){
			setSubtitle(`${translate("Resultado Chave")}: ${newSubTitle}`);
		}
	};

	useImperativeHandle(ref, () => ({
		openModalIniciative
	}));

	return (
		<Modal
			ref={modalAddOrChangeObjectives}
			withoutForm
			header={{
				title: translate("Iniciativas"),
				subtitle,
				icon: {
					name: "list"
				}
			}}
			footer= {{
				showSaveButton: false,
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Salvar"),
				cancelButtonText: translate("Cancelar")
			}}
			onClose={() => {
				if(onCallbackIniciativesFunction.current !== undefined){
					onCallbackIniciativesFunction.current();
				}
				if(onCallbackIniciatives !== undefined){
					onCallbackIniciatives();
				}					
			}}
		>
			<Iniciatives 
				idKr={idKr}
				permissions={permissions}
				idObjective={idObjective}
				disabled={disabled}
				subtitle={subtitle}
			/>
		</Modal>
	);
};

export default React.forwardRef(ModalIniciatives);
